import React, { Component } from 'react';
import ScrollableAnchor from 'react-scrollable-anchor'
import { push } from "../Services/Analytics"
import "./PlayBuzz.scss"

class PlayBuzz extends Component {
    constructor(props) {
        super();
        this.clickedToPlay = this.clickedToPlay.bind(this);
        this.state = {
            showPlayBuzz: false
        }
    }
    clickedToPlay() {
        push("Playbuzz_clicked", "");
        this.setState({
            showPlayBuzz: !this.state.showPlayBuzz
        })
    }
    render() {
        return (
            <ScrollableAnchor id="playbuzz">
                <section className={`section section-playbuzz ${this.state.showPlayBuzz ? " active" : ""}`}>
                    <div className="padding">
                        <div className="container">
                            <div className="headline">
                                <div className="head">
                                    איזה כדורגלן אתה?
                                </div>
                                <div className="desc">
                                    ענה על השאלון וגלה איפה אתה ממוקם על הסקאלה שבין כוכב ברמה העולמית, לפוטנציאל ברמה השכונתית
                                </div>
                            </div>
                            <div className="poster" onClick={this.clickedToPlay} style={{ display: (this.state.showPlayBuzz ? "none" : "block") }}>
                                <div className="image">
                                    <div className="button">
                                        <div className="text">
                                            בואו נתחיל!
                                     </div>
                                    </div>
                                </div>
                            </div>
                            <div className="game" style={{ display: (this.state.showPlayBuzz ? "block" : "none") }}>
                                <div className="playbuzz" data-id="9197e5fb-2a0d-46d6-b733-d1495296db83" data-show-share="false" data-show-info="false"></div>
                            </div>
                        </div>
                    </div>
                </section>
            </ScrollableAnchor>
        )
    }
}

export default PlayBuzz;


// WEBPACK FOOTER //
// ./src/Components/PlayBuzz/PlayBuzz.jsx